// tcData.js
export const tcData = [
  {
    tcNumber: "1035",
    dob: "17-08-2004",
    file: require("./assets/tc/ANSHI TIWARI 1035.jpeg"),
  },
  {
    tcNumber: "155",
    dob: "26-01-2010",
    file: require("./assets/tc/Anzar Azad 155.jpeg"),
  },
  {
    tcNumber: "2524",
    dob: "24-11-2011",
    file: require("./assets/tc/angel chandra 2524.jpeg"),
  },
  {
    tcNumber: "2593",
    dob: "13-10-2008",
    file: require("./assets/tc/Amit Verma 2593.jpg.jpeg"),
  },
  {
    tcNumber: "114",
    dob: "11-11-2003",
    file: require("./assets/tc/Amardeep 114.jpeg"),
  },
  {
    tcNumber: "975",
    dob: "27-09-2003",
    file: require("./assets/tc/Aman kumar 975.jpeg"),
  },
  {
    tcNumber: "1691",
    dob: "07-07-2006",
    file: require("./assets/tc/Aman Ansari.jpeg"),
  },
  {
    tcNumber: "1687",
    dob: "02-07-2005",
    file: require("./assets/tc/Akash verma 1687.jpeg"),
  },
  {
    tcNumber: "1071",
    dob: "16-11-2004",
    file: require("./assets/tc/Achal mishra 1071.jpeg"),
  },
  {
    tcNumber: "664",
    dob: "08-17-2006",
    file: require("./assets/tc/Abhishek singh 664.jpeg"),
  },
  {
    tcNumber: "2252",
    dob: "01-02-2017",
    file: require("./assets/tc/Abhinav shukla 2252.jpeg"),
  },
  {
    tcNumber: "278",
    dob: "04-09-2005",
    file: require("./assets/tc/Abdulla basir 278.jpeg"),
  },
  {
    tcNumber: "1871",
    dob: "26-10-2015",
    file: require("./assets/tc/Aarav shukla 1871.jpeg"),
  },
  {
    tcNumber: "2504",
    dob: "18-03-2016",
    file: require("./assets/tc/Aaradhay kumar Ojha 2504.jpeg"),
  },
  {
    tcNumber: "2633",
    dob: "20-02-2012",
    file: require("./assets/tc/2633 Shivangi shukla 1.jpg.jpeg"),
  },

  {
    tcNumber: "986",
    dob: "10-07-2005",
    file: require("./assets/tc/ARJUN TIWARI 986.jpeg"),
  },
  {
    tcNumber: "184",
    dob: "04-12-2006",
    file: require("./assets/tc/Arshad Kalam 184.jpeg"),
  },
  {
    tcNumber: "467",
    dob: "19-07-2008",
    file: require("./assets/tc/Chhavi verrma 467.jpeg"),
  },
  {
    tcNumber: "1483",
    dob: "23-07-2010",
    file: require("./assets/tc/Devid Raj 1483.jpeg"),
  },
  {
    tcNumber: "971",
    dob: "08-05-2006",
    file: require("./assets/tc/Dheeraj Verma 971.jpeg"),
  },
  {
    tcNumber: "518",
    dob: "15-08-2003",
    file: require("./assets/tc/Dilip 518.jpeg"),
  },
  {
    tcNumber: "2479",
    dob: "14-07-2008",
    file: require("./assets/tc/Dilip Kumar 2479.jpeg"),
  },
  {
    tcNumber: "141",
    dob: "29-01-2005",
    file: require("./assets/tc/Dipankar Roy.jpeg"),
  },
  {
    tcNumber: "1711",
    dob: "04-05-2003",
    file: require("./assets/tc/Faisal Khan 1711.jpeg"),
  },
  {
    tcNumber: "918",
    dob: "26-10-2005",
    file: require("./assets/tc/Mohd Ayan  918.jpeg"),
  },
  {
    tcNumber: "727",
    dob: "06-06-2004",
    file: require("./assets/tc/Mohd Saif 727.jpeg"),
  },
  {
    tcNumber: "805",
    dob: "24-09-2006",
    file: require("./assets/tc/Mohd Sameer 805.jpeg"),
  },
  {
    tcNumber: "215",
    dob: "24-07-2003",
    file: require("./assets/tc/mohd zai d 215.jpeg"),
  },
  {
    tcNumber: "512",
    dob: "20-04-2005",
    file: require("./assets/tc/Mohd. Asad 512.jpeg"),
  },
  {
    tcNumber: "662",
    dob: "29-07-2005",
    file: require("./assets/tc/Mohd. kaif 662.jpeg"),
  },
  {
    tcNumber: "1675",
    dob: "29-11-2006",
    file: require("./assets/tc/Falaq Qamar 1675.jpeg"),
  },
  {
    tcNumber: "968",
    dob: "01-08-2006",
    file: require("./assets/tc/Hasmuddin 968.jpeg"),
  },
  {
    tcNumber: "33",
    dob: "28-06-2007",
    file: require("./assets/tc/Himanshu raj 33.jpeg"),
  },
  {
    tcNumber: "1855",
    dob: "01-09-2012",
    file: require("./assets/tc/Jishan Ahmad 1855.jpeg"),
  },
  {
    tcNumber: "313",
    dob: "28-04-2005",
    file: require("./assets/tc/Juli Devi 313.jpeg"),
  },
  {
    tcNumber: "163",
    dob: "20-04-2010",
    file: require("./assets/tc/kartikkapoor 163.jpeg"),
  },
  {
    tcNumber: "1739",
    dob: "09-10-2008",
    file: require("./assets/tc/kashif qamar 1739.jpeg"),
  },
  {
    tcNumber: "956",
    dob: "20-07-2007",
    file: require("./assets/tc/Kuldeep kumar 956.jpeg"),
  },
  {
    tcNumber: "38",
    dob: "15-07-2004",
    file: require("./assets/tc/madhuram 38.jpeg"),
  },
  {
    tcNumber: "274",
    dob: "14-07-2005",
    file: require("./assets/tc/Manjeet singh 274.jpeg"),
  },
  {
    tcNumber: "662",
    dob: "29-07-2005",
    file: require("./assets/tc/Mohd. kaif 662.jpeg"),
  },
                  {
      tcNumber: "918",
    dob: "26-10-2005",
    file: require("./assets/tc/Mohd Ayan  918.jpeg"),
  },
                  {
      tcNumber: "573",
    dob: "23-06-2005",
    file: require("./assets/tc/mohd. Rehan 573.jpeg"),
  },
                  {
      tcNumber: "1678",
    dob: "01-01-2007",
    file: require("./assets/tc/navjot singh 1678.jpeg"),
  },
                  {
      tcNumber: "1090",
    dob: "08-06-2005",
    file: require("./assets/tc/Nikhil Gupta 1090.jpeg"),
  },
                  {
      tcNumber: "38",
    dob: "05-07-2006",
    file: require("./assets/tc/nitin kamar 38.jpeg"),
  },
                    {
      tcNumber: "880",
    dob: "05-12-2012",
    file: require("./assets/tc/nitya khanna 880.jpeg"),
  },
                    {
      tcNumber: "157",
    dob: "02-03-2005",
    file: require("./assets/tc/Pawanpreet Kaur 157.jpeg"),
  },
                    {
      tcNumber: "484",
    dob: "12-08-2006",
    file: require("./assets/tc/Priyanka verma 484.jpeg"),
  },
                    {
      tcNumber: "1241",
    dob: "05-05-2003",
    file: require("./assets/tc/Priyanshu Mehrotra.jpeg"),
  },
  
  {
   
    tcNumber: "1696",
    dob: "18-10-2004",
    file: require("./assets/tc/VIVEK KUMAE 1696.jpeg")
  },
  {
    name: "Qaynat Saniya",
    tcNumber: "199",
    dob: "16-05-2005",
    file: require("./assets/tc/qaynat saniya 199.jpeg")
  },
  {
    name: "Samiya Khan",
    tcNumber: "690",
    dob: "07-07-2005",
    file: require("./assets/tc/Samiya khan 690.jpeg")
  },
  {
    name: "Sandhya Raj",
    tcNumber: "1697",
    dob: "10-12-2004",
    file: require("./assets/tc/SANDHYA RAJ 1697.jpeg")
  },
  {
    name: "Sarah Atiq",
    tcNumber: "204",
    dob: "21-01-2007",
    file: require("./assets/tc/Sara Atiq 204.jpeg")
  },
  {
    name: "Satvinder Singh",
    tcNumber: "08",
    dob: "28-05-2005",
    file: require("./assets/tc/Satvinder singh 08.jpeg")
  },
  {
    name: "Shaban Khan",
    tcNumber: "638",
    dob: "15-07-2005",
    file: require("./assets/tc/Shaban Khan 638.jpeg")
  },
  {
    name: "Shahnawaz Ahmad",
    tcNumber: "637",
    dob: "08-07-2005",
    file: require("./assets/tc/shahnawaz 637.jpeg")
  },
  {
    name: "Shivam Shukla",
    tcNumber: "1685",
    dob: "01-10-2006",
    file: require("./assets/tc/Shivam Shukla 1685.jpeg")
  },
  {
    name: "Shivam Yadav",
    tcNumber: "357",
    dob: "08-10-2006",
    file: require("./assets/tc/Shivam Yadav 357.jpeg")
  }

];
